export default "__VITE_ASSET__DVUJIVa$__"